import React from "react";
import "./ExamPrep.css";
const A2ExamPrep = () => {
  return (
      <div className="a1ExamPrepCover">
        <h3>
          Goethe <span>A2 Exam</span> Preparation
        </h3>
        <p>
          German A2 level is the elementary level. To prepare for the Goethe A2:
        </p>
        <ul>
          <li>Read texts, like emails, simple articles, or short stories.</li>
          <li>
            Practice writing short texts on familiar topics, such as describing
            your hobbies, daily routines, or experiences.
          </li>
          <li>
            Listen to dialogues, podcasts, or watch videos in German to
            understand the context.
          </li>
        </ul>
      </div>
  );
};

export default A2ExamPrep;
